var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_284_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0019 0H0.566406V17.8809H17.0019V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_284_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.23633 17.8789H15.332C15.8529 17.8789 16.2614 17.7633 16.5576 17.5322C16.8538 17.3011 17.0019 16.9837 17.0019 16.58C17.0019 15.955 16.8115 15.2942 16.4307 14.5976C16.0498 13.901 15.5029 13.2483 14.79 12.6396C14.0771 12.0309 13.2145 11.5361 12.2021 11.1552C11.1898 10.7743 10.0488 10.5839 8.7793 10.5839C7.51628 10.5839 6.37858 10.7743 5.36621 11.1552C4.35384 11.5361 3.48958 12.0309 2.77344 12.6396C2.05729 13.2483 1.51041 13.901 1.13281 14.5976C0.755208 15.2942 0.566406 15.955 0.566406 16.58C0.566406 16.9837 0.714518 17.3011 1.01074 17.5322C1.30697 17.7633 1.71549 17.8789 2.23633 17.8789ZM8.78907 8.83594C9.48568 8.83594 10.1302 8.64551 10.7226 8.26465C11.3151 7.88379 11.792 7.36784 12.1533 6.7168C12.5146 6.06576 12.6953 5.33334 12.6953 4.51953C12.6953 3.71875 12.5146 3.00098 12.1533 2.36621C11.792 1.73145 11.3151 1.23178 10.7226 0.867188C10.1302 0.502604 9.48568 0.320312 8.78907 0.320312C8.09245 0.320312 7.44791 0.505859 6.85547 0.876953C6.26302 1.24805 5.78613 1.75261 5.42481 2.39063C5.06348 3.02865 4.88282 3.7448 4.88282 4.53907C4.88282 5.34636 5.06348 6.07389 5.42481 6.72168C5.78613 7.36947 6.26302 7.88379 6.85547 8.26465C7.44791 8.64551 8.09245 8.83594 8.78907 8.83594Z",
    fill: "#312E28"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonFill);
export default __webpack_public_path__ + "static/media/PersonFill.d697d822b11b9cb20ab8bda72c536252.svg";
export { ForwardRef as ReactComponent };